import { flexCollar as schema } from 'web/schemas/contentful/_schema.mjs';
import { fakeProps } from 'web/schemas/contentfulTestData';

const TestData = {
  header: 'Follow your dream, home.',
  bodyText:
    "We want to help you experience the best of life. From the magnificence of mountaintops to the sparkle of a skyline, whatever your passion, it's time to create a life within it.",
  flexCollarSlides: [
    {
      header: 'Water',
      img: '/assets/flexcollar/1.png',
      url: 'https://google.com/',
    },
    {
      header: 'Golf',
      img: '/assets/flexcollar/2.png',
      url: 'https://google.com/',
    },
    {
      header: 'Mountain',
      img: '/assets/flexcollar/3.png',
      url: 'https://google.com/',
    },
    {
      header: 'Wine',
      img: '/assets/flexcollar/4.png',
      url: 'https://google.com/',
    },
    {
      header: 'Ranch',
      img: '/assets/flexcollar/5.png',
      url: 'https://google.com/',
    },
    {
      header: 'Ski',
      img: '/assets/flexcollar/6.png',
      url: 'https://google.com/',
    },
    {
      header: 'Test 1',
      img: '/assets/flexcollar/5.png',
      url: 'https://google.com/',
    },
  ],
};

export default fakeProps(schema, TestData);
